import {
  Button,
  ButtonGroup,
  Hero,
  Page,
  Spinner,
  useAccessTokenManagement
} from '@hbo/ui-servicing-react-components';
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { RoutePath } from 'types/global';

const LoggedOut: React.FC = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state;

  const { isAuthenticated } = useAccessTokenManagement();

  if (state?.isLoggingOut && isAuthenticated) {
    return <Spinner isBranded isFullscreen />;
  }

  if (!state?.isLoggingOut && isAuthenticated) {
    return <Navigate to={RoutePath.CaseTracking} />;
  }

  return (
    <>
      <Helmet>
        <title>{t('loggedOut.title')}</title>
      </Helmet>
      <Hero>
        <Hero.PrimaryContent title={<Trans i18nKey="loggedOut.title" />} />
      </Hero>
      <Page>
        <Page.Content>
          <p>{t('loggedOut.message')}</p>
          <ButtonGroup>
            <Button
              variant="secondary"
              href={`${RoutePath.FourQuestionVerification}`}
              onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
                // Add adobe analytics code here, is needed
                event.preventDefault();
                navigate(RoutePath.FourQuestionVerification, { replace: true });
              }}
            >
              {t('generic.login')}
            </Button>
          </ButtonGroup>
        </Page.Content>
      </Page>
    </>
  );
};

export default LoggedOut;
